import { gql } from '@apollo/client';
const REMOVE_MODEL_COLORS = gql `
  mutation RemoveModelColors($modelSpecificationColorIds: [ID]!) {
    removeModelSpecificationColors(modelSpecificationColorIds: $modelSpecificationColorIds) {
      removed
    }
  }
`;
export default REMOVE_MODEL_COLORS;
